class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keydown', (event) => {
      if (event.code === 'Escape' && !event.repeat) this.escapePressStartedInside = true;
    });
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape' && this.escapePressStartedInside) this.close();
    });
    this.addEventListener('focusin', (event) => {
      if (this.overlayFocusState && !this.inert) this.overlayFocusState.target = event.target;
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !this.classList.contains('active')) return;
      const dialog = this.querySelector('.drawer-inner');
      const controls = getClickable(dialog).filter(node => node.getClientRects().length && getComputedStyle(node).visibility === 'visible' && node.getAttribute('aria-disabled') !== 'true');
      const first = controls[0], last = controls[controls.length - 1];
      if (first && ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last))) {
        event.preventDefault();
        event.stopPropagation();
        (event.shiftKey ? last : first).focus();
      }
    });
    this.addEventListener('click', (event) => {
      if (event.target.id === 'ajaxcart-overlay') this.close();
    });
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#ajax-cart-icon');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    clearTimeout(this.openTimer);
    cancelAnimationFrame(this.openFocusFrame);
    const previousFocus = document.activeElement;
    this.openTimer = setTimeout(() => {
      this.classList.add('animate', 'active');
      this.startOverlayFocusTracking();
      this.startHeaderPositioning();
      let frames = 0;
      const focusWhenVisible = () => {
        if (!this.classList.contains('active') || (document.activeElement !== previousFocus && document.activeElement !== document.body)) return;
        const target = this.querySelector('.close-ajax-cart');
        if (target && getComputedStyle(target).visibility === 'visible') this.trapCartFocus(target);
        else if (++frames < 5) this.openFocusFrame = requestAnimationFrame(focusWhenVisible);
      };
      this.openFocusFrame = requestAnimationFrame(focusWhenVisible);
    });
    document.body.classList.add('overflow-hidden');
  }
  close() {
    clearTimeout(this.openTimer);
    cancelAnimationFrame(this.openFocusFrame);
    this.classList.remove('active');
    this.stopOverlayFocusTracking();
    this.stopHeaderPositioning();
    triggerClickClose(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  startOverlayFocusTracking() {
    this.stopOverlayFocusTracking();
    const state = { covered: this.inert, target: this.contains(document.activeElement) ? document.activeElement : null };
    this.overlayFocusState = state;
    this.overlayFocusObserver = new MutationObserver(() => {
      if (this.overlayFocusState !== state || !this.classList.contains('active')) return;
      const resume = state.covered && !this.inert;
      state.covered = this.inert;
      if (state.covered) this.escapePressStartedInside = false;
      if (!resume) return;
      queueMicrotask(() => {
        if (this.overlayFocusState !== state || !this.isConnected || !this.classList.contains('active') || this.closest('[inert]')) return;
        const saved = state.target;
        const usable = saved && this.contains(saved) && !saved.disabled && saved.getAttribute('aria-disabled') !== 'true' && !saved.closest('[inert]') && saved.getClientRects().length && getComputedStyle(saved).visibility === 'visible';
        this.trapCartFocus(usable ? saved : this.querySelector('.close-ajax-cart'));
      });
    });
    this.overlayFocusObserver.observe(this, { attributes: true, attributeFilter: ['inert'] });
  }
  stopOverlayFocusTracking() {
    if (this.overlayFocusObserver) this.overlayFocusObserver.disconnect();
    this.overlayFocusObserver = null;
    this.overlayFocusState = null;
    this.escapePressStartedInside = false;
  }
  startHeaderPositioning() {
    this.stopHeaderPositioning();
    this.headerResizeHandler = () => this.syncHeaderPositioning();
    window.addEventListener('resize', this.headerResizeHandler, { passive: true });
    this.syncHeaderPositioning();
  }
  syncHeaderPositioning() {
    if (!this.isConnected || !this.classList.contains('active')) return this.stopHeaderPositioning();
    if (!window.matchMedia('(max-width: 767px), (max-height: 650px)').matches) return this.stopHeaderTracking();
    const header = document.querySelector('header.header') || document.querySelector('header');
    if (this.headerTracking && this.headerTracking.header === header) return this.headerTracking.queue();
    this.stopHeaderTracking();
    if (!header) return;
    const wrapper = header.closest('.shopify-section-group-header-group');
    const nodes = wrapper && wrapper !== header ? [header, wrapper] : [header];
    const state = { header, nodes, frame: 0, deadline: 0 };
    this.headerTracking = state;
    const measure = () => {
      state.frame = 0;
      if (this.headerTracking !== state || !this.isConnected || !this.classList.contains('active')) return;
      if (!header.isConnected) return this.syncHeaderPositioning();
      const rect = header.getBoundingClientRect();
      const visible = header.isConnected && getComputedStyle(header).visibility !== 'hidden' && rect.height > 0 && rect.width > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
      const value = (visible ? Math.min(innerHeight, Math.max(0, Math.ceil(rect.bottom))) : 0) + 'px';
      if (this.style.getPropertyValue('--fbp-cart-header-bottom') !== value) this.style.setProperty('--fbp-cart-header-bottom', value);
      const moving = nodes.some(node => typeof node.getAnimations === 'function' && node.getAnimations().some(animation => animation.playState === 'running' && animation.effect && Number.isFinite(animation.effect.getComputedTiming().endTime)));
      if (moving && performance.now() < state.deadline) state.frame = requestAnimationFrame(measure);
      else state.deadline = 0;
    };
    state.queue = () => {
      if (this.headerTracking !== state || state.frame) return;
      if (!state.deadline) state.deadline = performance.now() + 2000;
      state.frame = requestAnimationFrame(measure);
    };
    state.transition = event => { if (nodes.includes(event.target)) state.queue(); };
    window.addEventListener('scroll', state.queue, { passive: true });
    nodes.forEach(node => {
      node.addEventListener('transitionrun', state.transition);
      node.addEventListener('transitionend', state.transition);
      node.addEventListener('transitioncancel', state.transition);
    });
    state.resize = new ResizeObserver(state.queue);
    state.mutation = new MutationObserver(state.queue);
    nodes.forEach(node => {
      state.resize.observe(node);
      state.mutation.observe(node, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    });
    state.deadline = performance.now() + 2000;
    measure();
  }
  stopHeaderTracking() {
    const state = this.headerTracking;
    this.headerTracking = null;
    if (state) {
      cancelAnimationFrame(state.frame);
      window.removeEventListener('scroll', state.queue);
      state.resize.disconnect();
      state.mutation.disconnect();
      state.nodes.forEach(node => {
        node.removeEventListener('transitionrun', state.transition);
        node.removeEventListener('transitionend', state.transition);
        node.removeEventListener('transitioncancel', state.transition);
      });
    }
    this.style.removeProperty('--fbp-cart-header-bottom');
  }
  stopHeaderPositioning() {
    if (this.headerResizeHandler) window.removeEventListener('resize', this.headerResizeHandler);
    this.headerResizeHandler = null;
    this.stopHeaderTracking();
  }
  disconnectedCallback() {
    clearTimeout(this.openTimer);
    cancelAnimationFrame(this.openFocusFrame);
    this.stopOverlayFocusTracking();
    this.stopHeaderPositioning();
  }
  trapCartFocus(target) {
    const dialog = this.querySelector('.drawer-inner');
    if (dialog && target && this.classList.contains('active')) triggerClick(dialog, target);
  }
  replaceCartSection(source) {
    const section = source.querySelector('#ajaxcart');
    if (!section) throw new Error('Cart drawer section unavailable');
    const focused = document.activeElement;
    const hadFocus = this.contains(focused);
    const focusId = focused && focused.id;
    const focusedVariant = focused && focused.dataset.quantityVariantId;
    const previousItemCount = this.querySelectorAll('.cart-item').length;
    const note = this.querySelector('#ajaxcart-note');
    const unsavedNote = note && note.value !== note.defaultValue ? note.value : null;
    this.querySelector('#ajaxcart').innerHTML = section.innerHTML;
    const sourceDrawer = source.querySelector('ajax-cart');
    this.classList.toggle('is-empty', Boolean(sourceDrawer && sourceDrawer.classList.contains('is-empty')));
    const newNote = this.querySelector('#ajaxcart-note');
    if (newNote && unsavedNote !== null) newNote.value = unsavedNote;
    if (hadFocus && this.classList.contains('active')) {
      const sameItems = previousItemCount === this.querySelectorAll('.cart-item').length;
      const target = focusId && Array.from(this.querySelectorAll('[id]')).find(node => node.id === focusId && (!focusedVariant || (sameItems && node.dataset.quantityVariantId === focusedVariant)));
      this.trapCartFocus(target || this.querySelector('.close-ajax-cart'));
    }
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', escClick);
  }
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.replaceCartSection(new DOMParser().parseFromString(parsedState.sections['ajax-cart'], 'text/html'));
    const icon = document.getElementById('ajax-cart-icon');
    if (icon) icon.innerHTML = this.callSectionInnerHTML(parsedState.sections['ajax-cart-icon']);
    this.open();
  }
  callSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  fetchSecToInclude() {
    return [
      {
        id: 'ajax-cart',
        selector: '#ajaxcart'
      },
      {
        id: 'ajax-cart-icon'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('ajax-cart', ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return fbpCartSections();
  }
}

customElements.define('cart-pro', ajaxCartPro);
